import { render, staticRenderFns } from "./SSOConnectPopup.vue?vue&type=template&id=454f44ae&scoped=true"
import script from "./SSOConnectPopup.vue?vue&type=script&lang=js"
export * from "./SSOConnectPopup.vue?vue&type=script&lang=js"
import style0 from "./SSOConnectPopup.vue?vue&type=style&index=0&id=454f44ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f44ae",
  null
  
)

export default component.exports